import { render } from "./FormDni.vue?vue&type=template&id=ec7e90d0&ts=true"
import script from "./FormDni.vue?vue&type=script&lang=ts"
export * from "./FormDni.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__